import script from "./MicrioViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MicrioViewer.vue?vue&type=script&setup=true&lang=ts"

import "./MicrioViewer.vue?vue&type=style&index=0&id=0203c7fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0203c7fa"]])

export default __exports__